import { Spacings } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  wrapper: {
    padding: Spacings.s12,
  },
  snackbar: {
    borderRadius: 'var(--radius-12)',
  },
});

export default useStyles;
